export const TakeoffVariableActionStatus = {
    Unchanged: { id: 1, text: "Unchanged",      i18nKey: "Unchanged" },
    Modified:  { id: 2, text: "Value Modified", i18nKey: "ValueModified", color: "#bdd7ee" },
    New:       { id: 3, text: "New Variable",   i18nKey: "NewVariable",   color: "#92d050" },
    Deleted:   { id: 4, text: "Deleted",        i18nKey: "Deleted",       color: "#f27979" }
};